// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1fnFc","content":"GlobalSearch_content__1IKOL"};